var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddonsDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "addons_dark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_46260",
    "data-name": "Path 46260",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46261",
    "data-name": "Path 46261",
    d: "M20.5,11H19V7a2.006,2.006,0,0,0-2-2H13V3.5a2.5,2.5,0,0,0-5,0V5H4A2,2,0,0,0,2.01,7v3.8H3.5a2.7,2.7,0,0,1,0,5.4H2V20a2.006,2.006,0,0,0,2,2H7.8V20.5a2.7,2.7,0,1,1,5.4,0V22H17a2.006,2.006,0,0,0,2-2V16h1.5a2.5,2.5,0,0,0,0-5Z",
    fill: "#4b4e6d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddonsDark);
export default __webpack_public_path__ + "static/media/addons_dark.c74166fe4443bbe3ebf8c18ed63d58b2.svg";
export { ForwardRef as ReactComponent };